export default __webpack_public_path__ + "static/media/part-history.5083a26d.png";